import { Component, OnInit, input } from "@angular/core";

@Component({
  selector: "av-flip",
  templateUrl: "./flip.component.html",
  styleUrls: ["./flip.component.scss"],
  standalone: false,
})
export class FlipComponent implements OnInit {
  readonly flipped = input<boolean>(undefined);

  constructor() {}

  ngOnInit(): void {}
}
